function StarReview({ setSelectedStar, selectedStar }) {
  const handleSelectFiledStar = (star) => {
    if (selectedStar === star) {
      setSelectedStar(0);
      return;
    }
    setSelectedStar(star);
  };

  return (
    <>
      {/* 1 Star */}
      <div
        className="prod-star-wrapper"
        onClick={() => handleSelectFiledStar(1)}
        style={{ cursor: "pointer" }}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 30 30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="15"
            cy="15"
            r="13"
            stroke={selectedStar === 1 ? "#cc4e00" : "#cc4e00"}
            strokeWidth="2"
            fill={selectedStar === 1 ? "#fc9700" : "none"}
          />
          <g transform="translate(15,15) scale(0.6)">
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 1 ? "#cc4e00" : "#cc4e00"}
            />
          </g>
        </svg>
        <span>≥1</span>
      </div>

      {/* 2 Stars */}
      <div
        className="prod-star-wrapper"
        onClick={() => handleSelectFiledStar(2)}
        style={{ cursor: "pointer" }}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 30 30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="15"
            cy="15"
            r="13"
            stroke={selectedStar === 2 ? "#cc4e00" : "#cc4e00"}
            strokeWidth="2"
            fill={selectedStar === 2 ? "#fc9700" : "none"}
          />
          <g transform="translate(15,15) scale(0.5)">
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 2 ? "#cc4e00" : "#cc4e00"}
              transform="translate(-7,-7)"
            />
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 2 ? "#cc4e00" : "#cc4e00"}
              transform="translate(7,7)"
            />
          </g>
        </svg>
        <span>≥2</span>
      </div>

      {/* 3 Stars */}
      <div
        className="prod-star-wrapper"
        onClick={() => handleSelectFiledStar(3)}
        style={{ cursor: "pointer" }}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 30 30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="15"
            cy="15"
            r="13"
            stroke={selectedStar === 3 ? "#cc4e00" : "#cc4e00"}
            strokeWidth="2"
            fill={selectedStar === 3 ? "#fc9700" : "none"}
          />
          <g transform="translate(15,15) scale(0.4)">
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 3 ? "#cc4e00" : "#cc4e00"}
              transform="translate(0,-10)"
            />
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 3 ? "#cc4e00" : "#cc4e00"}
              transform="translate(-10,7)"
            />
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 3 ? "#cc4e00" : "#cc4e00"}
              transform="translate(10,7)"
            />
          </g>
        </svg>
        <span>≥3</span>
      </div>

      {/* 4 Stars */}
      <div
        className="prod-star-wrapper"
        onClick={() => handleSelectFiledStar(4)}
        style={{ cursor: "pointer" }}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 30 30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="15"
            cy="15"
            r="13"
            stroke={selectedStar === 4 ? "#cc4e00" : "#cc4e00"}
            strokeWidth="2"
            fill={selectedStar === 4 ? "#fc9700" : "none"}
          />
          <g transform="translate(15,15) scale(0.4)">
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 4 ? "#cc4e00" : "#cc4e00"}
              transform="translate(-10,-10)"
            />
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 4 ? "#cc4e00" : "#cc4e00"}
              transform="translate(10,-10)"
            />
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 4 ? "#cc4e00" : "#cc4e00"}
              transform="translate(10,10)"
            />
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 4 ? "#cc4e00" : "#cc4e00"}
              transform="translate(-10,10)"
            />
          </g>
        </svg>
        <span>≥4</span>
      </div>

      {/* 5 Stars */}
      <div
        className="prod-star-wrapper"
        onClick={() => handleSelectFiledStar(5)}
        style={{ cursor: "pointer" }}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 30 30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="15"
            cy="15"
            r="13"
            stroke={selectedStar === 5 ? "#cc4e00" : "#cc4e00"}
            strokeWidth="2"
            fill={selectedStar === 5 ? "#fc9700" : "none"}
          />
          <g transform="translate(15,15) scale(0.4)">
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 5 ? "#cc4e00" : "#cc4e00"}
              transform="translate(0,-14)"
            />
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 5 ? "#cc4e00" : "#cc4e00"}
              transform="translate(-14,-3)"
            />
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 5 ? "#cc4e00" : "#cc4e00"}
              transform="translate(14,-3)"
            />
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 5 ? "#cc4e00" : "#cc4e00"}
              transform="translate(8,13)"
            />
            <polygon
              points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
              fill={selectedStar === 5 ? "#cc4e00" : "#cc4e00"}
              transform="translate(-8,13)"
            />
          </g>
        </svg>
        <span>5</span>
      </div>
    </>
  );
}

export default StarReview;
